// Create a common handler for the MktoForms2 callback.
function handleMktoForm() {
  const newForms = document.querySelectorAll(
    '[data-marketo-form]:not(.loaded)'
  );

  Array.from(newForms).forEach(element => {
    const { marketoUrl, marketoMunchkin, marketoForm } = element.dataset;
    MktoForms2.loadForm(marketoUrl, marketoMunchkin, marketoForm);
    console.log('MktoForms2',MktoForms2);
    
    element.classList.add('loaded');
  });

  MktoForms2.whenReady(function (form) {
    let btnText = null;
    form.onSubmit(form => {
      btnText = form.getFormElem()[0].querySelector('button').innerText;
    });
    form.onSuccess(function (values, thankYouURL) {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: 'mktoFormSuccess',
        formId: form.getId(),
        leadEmail: values.Email,
      });

      // toast
      const toast = document.getElementById('toast');
      toast.insertAdjacentHTML(
        'beforeend',
        '<p>Success. Thank you for your submission!</p>'
      );
      toast.classList.add('visible');
      //  RESET FORM
      form.submittable(true);
      form.getFormElem()[0].reset();
      form.getFormElem()[0].querySelector('button').innerText = btnText;
      form.getFormElem()[0].querySelector('button').removeAttribute('disabled');

      /* The `return false;` statement in the `onSuccess` callback function is not necessary and will
      not have any effect in this context. */
      setTimeout(() => {
        toast.classList.remove('visible');
      }, 5000);
      setTimeout(() => {
        toast.innerHTML = '';
      }, 5500);
      // Return true to proceed with the default submission.
      // return true;
      return false;
    });
  });
}
window.addEventListener('page:ready', handleMktoForm, { passive: true });



//////////////////
// WEBPACK FOOTER
// ./scripts/util/MarketoForms.js
// module id = 77
// module chunks = 0